var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ApexChart',{attrs:{"height":_vm.height,"options":_vm.options,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }